module.exports = __webpack_public_path__ + "static/media/image3.f7a11df4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/apps/BCOMS/resources/preConference/image3.jpg
// module id = 1131
// module chunks = 0